import { z } from 'zod';

/**
 * The app's `z`. Schemas import it from here rather than from 'zod' so this
 * configuration is loaded before any of them parse.
 *
 * zod 4 words a missing value "Invalid input: expected string, received
 * undefined", and forms show that default to people. A missing value reads
 * "Required" instead, as it did on zod 3. A schema's own message still wins.
 */
z.config({
  customError: (issue) =>
    issue.input === undefined &&
    (issue.code === 'invalid_type' || issue.code === 'invalid_value')
      ? 'Required'
      : undefined,
});

export { z };
